export default class ConvertHeight {
  constructor(elements) {
    this.elements = elements
    this.classesHeightChild = '.js-height-item'
  }

  convertHeight() {
    if (this.elements.hasClass('mod-carousel-video__content')) {
      this.classesHeightChild = '.mod-carousel-video__content'
    }

    if (this.elements.hasClass('mod-carousel-video__item')) {
      this.classesHeightChild = '.mod-carousel-video__item'
    }

    const groups = {}

    this.elements.each((_index, el) => {
      const element = $(el)
      element.height('')
      element.find(this.classesHeightChild).height('')
      const offsetTop = element.offset().top

      if (!groups[offsetTop]) {
        groups[offsetTop] = []
      }

      groups[offsetTop].push(element)
    })

    Object.values(groups).forEach((group) => {
      if (group.length > 1) {
        const heights = group.map((el) => {
          el.height('auto')
          el.find(this.classesHeightChild).height('auto')
          return el.find(this.classesHeightChild).length ? el.find(this.classesHeightChild).height() : el.height()
        })

        const maxHeight = Math.max(...heights)
        group.forEach((el) =>
          el.find(this.classesHeightChild).length
            ? el.find(this.classesHeightChild).height(maxHeight)
            : el.height(maxHeight),
        )
      }
    })
  }
}
